import type { LocalStateOps } from '@mimir/client-common/fileSync/localStateOps';
import type { UploadItem } from '@mimir/client-common/upload/UploadItem';
import type { AdobePanelContext, ElectronContext } from '@mimir/common/context/applicationContext';
import { getGlobalStore } from '@mimir/web/store';
import type { StorageProfile } from './storageSettings';

export async function storeDispatchLoadStorageProfile(
  applicationContext: AdobePanelContext | ElectronContext,
  toOpenPremiereProject: boolean,
  ongoingUploads: UploadItem[],
  downloadPath: string,
  localStateOps: LocalStateOps,
): Promise<StorageProfile | undefined> {
  return await getGlobalStore().dispatch('loadStorageProfile', {
    applicationContext,
    toOpenPremiereProject,
    ongoingUploads,
    downloadPath,
    localStateOps,
  });
}
